export const getTokenData = () => {
    const token = localStorage.getItem("token");
    if (!token) return null;
  
    try {
      const payload = token.split('.')[1];
      const decoded = JSON.parse(atob(payload));
      return decoded;
    } catch (error) {
      console.error("Error al decodificar el token:", error);
      return null;
    }
  };
  